import request from '@/utils/request'

export function reg(form) {
	return request.post('cust/register', form);
}

export function register(form) {
	return request.post('cust/register', form);
}

export function v1Login(form) {
	return request.post('cust/v1/login', form);
}

export function login(form) {
	return request.post('cust/login', form);
}

/**
 * 发送验证码
 * @param {*} {
 * phone
 * sign
 * r
 * } 
 * @returns 
 */
export function sendcode(params) {
	return request.post('cust/de6GMcC9LtL0vR0q', params);
}

export function realname(form) {
	return request.post('cust/realname', form);
}

export function tradepwd(form) {
	return request.post('cust/tradepwd', form);
}

export function userInfo() {
	return request.post('cust/getuser');
}

export function paylist() {
	return request.post('cust/paylist');
}

export function buyper() {
	return request.post('cust/buypre');
}

export function getReferrer(form) {
	return request.post('cust/getReferrer', form);
}

export function getCustomerList() {
	return request.post('/customer/list')
}